import React, { useState } from 'react';
import { AlertCircleIcon, CheckCircleIcon, XIcon } from 'lucide-react';
interface AdminApprovalProps {
  isVisible: boolean;
  onClose: () => void;
  onApprove: () => void;
  onReject: () => void;
  title: string;
  description: string;
}
export function AdminApproval({
  isVisible,
  onClose,
  onApprove,
  onReject,
  title,
  description
}: AdminApprovalProps) {
  const [comment, setComment] = useState('');
  if (!isVisible) return null;
  return <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" data-id="element-74">
      <div className="bg-white rounded-lg shadow-lg w-full max-w-md p-6" data-id="element-75">
        <div className="flex justify-between items-center mb-4" data-id="element-76">
          <h3 className="text-lg font-semibold text-[#1A1F36]" data-id="element-77">{title}</h3>
          <button onClick={onClose} className="text-gray-500 hover:text-gray-700" data-id="element-78">
            <XIcon size={20} data-id="element-79" />
          </button>
        </div>
        <div className="mb-4" data-id="element-80">
          <p className="text-gray-600" data-id="element-81">{description}</p>
        </div>
        <div className="mb-4" data-id="element-82">
          <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-83">
            Comments (optional)
          </label>
          <textarea value={comment} onChange={e => setComment(e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#F58220] focus:border-transparent" rows={3} placeholder="Add your comments here..." data-id="element-84"></textarea>
        </div>
        <div className="flex justify-end space-x-3" data-id="element-85">
          <button onClick={onReject} className="flex items-center px-4 py-2 border border-red-500 text-red-500 rounded-md hover:bg-red-50" data-id="element-86">
            <AlertCircleIcon size={16} className="mr-2" data-id="element-87" />
            Reject
          </button>
          <button onClick={onApprove} className="flex items-center px-4 py-2 bg-[#F58220] text-white rounded-md hover:bg-[#e07619]" data-id="element-88">
            <CheckCircleIcon size={16} className="mr-2" data-id="element-89" />
            Approve
          </button>
        </div>
      </div>
    </div>;
}